// extracted by css-extract-rspack-plugin
export default {"section-title":"ListingBodySection-module__section-title___Exu6"};